import { useState } from 'react';

const GRID_TYPES = [
  { id: 'square', label: 'Square' },
  { id: 'dot', label: 'Dot' },
  { id: 'isometric', label: 'Isometric' },
  { id: 'hexagonal', label: 'Hex' },
  { id: 'polar', label: 'Polar' },
  { id: 'engineering', label: 'Engineer' },
  { id: 'lined', label: 'Lined' },
];

const SPACING_OPTIONS = [
  { value: 2, label: '2 mm' },
  { value: 3, label: '3 mm' },
  { value: 5, label: '5 mm' },
  { value: 6.35, label: '¼″' },
  { value: 7.5, label: '7.5 mm' },
  { value: 10, label: '1 cm' },
  { value: 12.7, label: '½″' },
  { value: 25.4, label: '1″' },
];

const LINE_COLORS = [
  { value: '#1a1a1a', label: 'Black' },
  { value: '#3b82f6', label: 'Blue' },
  { value: '#ef4444', label: 'Red' },
  { value: '#22c55e', label: 'Green' },
  { value: '#a855f7', label: 'Purple' },
  { value: '#f59e0b', label: 'Amber' },
  { value: '#6b7280', label: 'Gray' },
  { value: '#d1d5db', label: 'Light Gray' },
];

const PAGE_SIZES = [
  { id: 'letter', label: 'Letter' },
  { id: 'a4', label: 'A4' },
  { id: '11x17', label: '11×17' },
  { id: 'legal', label: 'Legal' },
  { id: 'a3', label: 'A3' },
  { id: 'a2', label: 'A2' },
  { id: 'poster', label: 'Poster' },
  { id: 'movie-poster', label: 'Movie' },
];

const ACCENT_OPTIONS = [
  { value: 0, label: 'Off' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 10, label: '10' },
];

function TypeIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="12" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="12" width="7" height="7" rx="1" />
      <rect x="12" y="12" width="7" height="7" rx="1" />
    </svg>
  );
}

function SizeIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 11h16" />
      <path d="M11 3v16" />
      <path d="M7 7l4-4 4 4" />
      <path d="M7 15l4 4 4-4" />
    </svg>
  );
}

function ColorIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <path d="M11 3a8 8 0 010 16" />
    </svg>
  );
}

function WeightIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M4 6h14" strokeWidth="1" />
      <path d="M4 11h14" strokeWidth="1.5" />
      <path d="M4 16h14" strokeWidth="2.5" />
    </svg>
  );
}

function PageIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="14" height="18" rx="2" />
      <path d="M8 7h6" />
      <path d="M8 11h6" />
      <path d="M8 15h4" />
    </svg>
  );
}

function OrientIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="3" width="12" height="16" rx="1" />
      <path d="M11 3v16" />
      <path d="M8 6l3-3 3 3" />
    </svg>
  );
}

function AccentIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="16" height="16" rx="1" />
      <path d="M3 11h16" strokeWidth="2.5" />
      <path d="M11 3v16" strokeWidth="2.5" />
    </svg>
  );
}

function PrintIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 8V4h8v4" />
      <rect x="4" y="8" width="14" height="7" rx="1.5" />
      <path d="M7 13h8v6H7z" />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4v11" />
      <path d="M7 11l4 4 4-4" />
      <path d="M4 18v1h14v-1" />
    </svg>
  );
}

export default function MobileToolbar({ settings, onChange, onPrint, onDownload }) {
  const [activeCategory, setActiveCategory] = useState(null);

  const categories = [
    { id: 'gridType', label: 'Type', icon: <TypeIcon /> },
    { id: 'gridSize', label: 'Size', icon: <SizeIcon /> },
    { id: 'color', label: 'Color', icon: <ColorIcon /> },
    { id: 'lineWeight', label: 'Weight', icon: <WeightIcon /> },
    { id: 'pageSize', label: 'Page', icon: <PageIcon /> },
    { id: 'orientation', label: 'Orient', icon: <OrientIcon /> },
    ...(settings.type === 'square' || settings.type === 'engineering' ? [{ id: 'accent', label: 'Accent', icon: <AccentIcon /> }] : []),
  ];

  const toggleCategory = (id) => {
    setActiveCategory((prev) => (prev === id ? null : id));
  };

  return (
    <div className="mobile-toolbar">
      {activeCategory && <div className="mobile-toolbar-overlay" onClick={() => setActiveCategory(null)} />}
      <div className={`mobile-toolbar-panel ${activeCategory ? 'open' : ''}`}>
        <div className="mobile-toolbar-panel-inner">
          {activeCategory === 'gridType' && (
            <div className="mt-options-row">
              {GRID_TYPES.map((gt) => (
                <button
                  key={gt.id}
                  className={`mt-option-btn ${settings.type === gt.id ? 'active' : ''}`}
                  onClick={() => { onChange('type', gt.id); setActiveCategory(null); }}
                >
                  {gt.label}
                </button>
              ))}
            </div>
          )}
          {activeCategory === 'gridSize' && (
            <div className="mt-options-row">
              {SPACING_OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  className={`mt-option-btn ${settings.spacing === opt.value ? 'active' : ''}`}
                  onClick={() => { onChange('spacing', opt.value); setActiveCategory(null); }}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          )}
          {activeCategory === 'color' && (
            <div className="mt-options-row">
              {LINE_COLORS.map((c) => (
                <button
                  key={c.value}
                  className={`mt-color-btn ${settings.color === c.value ? 'active' : ''}`}
                  style={{ backgroundColor: c.value }}
                  onClick={() => { onChange('color', c.value); }}
                  title={c.label}
                />
              ))}
            </div>
          )}
          {activeCategory === 'lineWeight' && (
            <div className="mt-sliders-wrap">
              {(settings.type === 'square' || settings.type === 'engineering') ? (
                <>
                  <div className="mt-slider-row">
                    <span className="mt-slider-label">{settings.minorWidth.toFixed(1)} px</span>
                    <input
                      type="range" min="0.1" max="1.5" step="0.1"
                      value={settings.minorWidth}
                      onChange={(e) => onChange('minorWidth', parseFloat(e.target.value))}
                      className="mt-slider"
                    />
                    <span className="mt-slider-name">Small</span>
                  </div>
                  <div className="mt-slider-row">
                    <span className="mt-slider-label">{settings.majorWidth.toFixed(1)} px</span>
                    <input
                      type="range" min="0.3" max="3" step="0.1"
                      value={settings.majorWidth}
                      onChange={(e) => onChange('majorWidth', parseFloat(e.target.value))}
                      className="mt-slider"
                    />
                    <span className="mt-slider-name">Large</span>
                  </div>
                </>
              ) : (
                <div className="mt-slider-row">
                  <span className="mt-slider-label">{settings.minorWidth.toFixed(1)} px</span>
                  <input
                    type="range" min="0.1" max="3" step="0.1"
                    value={settings.minorWidth}
                    onChange={(e) => onChange('minorWidth', parseFloat(e.target.value))}
                    className="mt-slider"
                  />
                  <span className="mt-slider-name">Weight</span>
                </div>
              )}
            </div>
          )}
          {activeCategory === 'pageSize' && (
            <div className="mt-options-row">
              {PAGE_SIZES.map((ps) => (
                <button
                  key={ps.id}
                  className={`mt-option-btn ${settings.pageSize === ps.id ? 'active' : ''}`}
                  onClick={() => { onChange('pageSize', ps.id); setActiveCategory(null); }}
                >
                  {ps.label}
                </button>
              ))}
            </div>
          )}
          {activeCategory === 'orientation' && (
            <div className="mt-options-row">
              <button
                className={`mt-orient-btn ${settings.orientation === 'portrait' ? 'active' : ''}`}
                onClick={() => onChange('orientation', 'portrait')}
              >
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="5" y="3" width="12" height="16" rx="1" /></svg>
                Portrait
              </button>
              <button
                className={`mt-orient-btn ${settings.orientation === 'landscape' ? 'active' : ''}`}
                onClick={() => onChange('orientation', 'landscape')}
              >
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="5" width="16" height="12" rx="1" /></svg>
                Landscape
              </button>
            </div>
          )}
          {activeCategory === 'accent' && (
            <div className="mt-options-row">
              {ACCENT_OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  className={`mt-option-btn ${settings.accentEvery === opt.value ? 'active' : ''}`}
                  onClick={() => { onChange('accentEvery', opt.value); setActiveCategory(null); }}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="mobile-toolbar-bar">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`mt-bar-btn ${activeCategory === cat.id ? 'active' : ''}`}
            onClick={() => toggleCategory(cat.id)}
          >
            <span className="mt-bar-icon">{cat.icon}</span>
            <span className="mt-bar-label">{cat.label}</span>
          </button>
        ))}
        {onPrint && (
          <button
            className="mt-bar-btn"
            onClick={onPrint}
          >
            <span className="mt-bar-icon"><PrintIcon /></span>
            <span className="mt-bar-label">Print</span>
          </button>
        )}
        {onDownload && (
          <button
            className="mt-bar-btn"
            onClick={() => onDownload('pdf')}
          >
            <span className="mt-bar-icon"><DownloadIcon /></span>
            <span className="mt-bar-label">Download</span>
          </button>
        )}
      </div>
    </div>
  );
}
